export enum HedgingModeType {
  NONE,
  AUTO,
  MANUAL,
}

export namespace HedgingModeType {
  let elements = [HedgingModeType.NONE, HedgingModeType.AUTO, HedgingModeType.MANUAL];
  let alias = "com.bcdfx.model.HedgingModeType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
